import {
  FETCH_SERVICE_VENDORS,
  FETCH_SERVICE_VENDOR_BY_BULSTAT
} from "@/modules/service-vendors/store/service-vendors.module";

export const serviceInvoiceAiMixin = {
  data() {
    return {
      serviceVendors: []
    };
  },
  methods: {
    async loadServiceVendorDependencies() {
      await this.loadServiceVendors();
    },

    async loadServiceVendors() {
      try {
        const data = await this.$store.dispatch(
          FETCH_SERVICE_VENDORS,
          this.$url.transformParams({
            onlySelectValues: true,
            selectValueKey: "name"
          })
        );
        this.serviceVendors = data.data.items || data.data || [];
      } catch (error) {
        console.error("Error loading service vendors:", error);
      }
    },

    async autoMatchServiceVendor(form) {
      if (!this.aiInvoiceData) return;

      const supplierVat = this.aiInvoiceData.supplierVat;
      const supplierName = this.aiInvoiceData.supplierName;

      // Try matching by VAT/Bulstat first
      if (supplierVat) {
        const matched = await this.fetchServiceVendorByBulstat(supplierVat);

        if (matched) {
          form.serviceVendorId = matched.id;

          this.$notify({
            group: "notify",
            type: "success",
            text:
              this.$t("LABELS.SERVICE_VENDOR_AUTO_MATCHED_BY_VAT", {
                name: matched.name,
                vat: supplierVat
              }) ||
              `Service vendor auto-matched by VAT: ${matched.name} (${supplierVat})`
          });
          return;
        }
      }

      // Try matching by name if VAT match failed
      if (supplierName && this.serviceVendors.length > 0) {
        const matched = this.autoMatchByName(
          this.serviceVendors,
          supplierName,
          "name"
        );

        if (matched) {
          form.serviceVendorId = matched.id;

          this.$notify({
            group: "notify",
            type: "info",
            text:
              this.$t("LABELS.SERVICE_VENDOR_AUTO_MATCHED_BY_NAME", {
                name: matched.name
              }) || `Service vendor auto-matched by name: ${matched.name}`
          });
        }
      }
    },

    async fetchServiceVendorByBulstat(bulstat) {
      if (!bulstat) return null;

      try {
        const response = await this.$store.dispatch(
          FETCH_SERVICE_VENDOR_BY_BULSTAT,
          bulstat
        );
        return response.data || response;
      } catch (error) {
        console.error("Error fetching service vendor by bulstat:", error);
        return null;
      }
    },

    autoPopulateServiceRows(form) {
      if (!this.aiInvoiceData?.rows || !this.aiInvoiceData.rows.length) return;

      form.rows = this.aiInvoiceData.rows.map(aiRow => {
        return {
          id: null,
          name: aiRow.itemName || "",
          code: "",
          price: parseFloat(aiRow.itemPrice) || 0,
          totalQty: parseFloat(aiRow.itemQuantity) || 0,
          totalPrice: parseFloat(aiRow.itemTotalPrice) || 0,
          serviceWarehouseItemId: null,
          code: aiRow.itemCode,
          machineId: null,
          machine: null,
          _aiInvoiceRowId: aiRow.id,
          _aiDiscount: aiRow.itemDiscountPercentage
        };
      });

      // Update totals based on rows
      form.totalNoVat = this.calculateTotalNoVat(form.totalWithVat, form.vat);
    }
  }
};
